import { faPlay, faStop } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dispatch, SetStateAction } from "react";
import { useAtendimentoPage } from "../../../../../../Context/AtendimentoPage";
import { ReiniciarAtendimentoController } from "../../../../../../Controllers/AssistenciaTecnica/Atendimento/AcoesAtendimento/AcoesAtendimentoControllers";
import useAsyncCallback from "../../../../../../hooks/useAsyncCallback";
import { IAtendimentoExtraDetalhado } from "../../../../../../Interfaces/Geral/Atendimento/AtendimentoExtraDetalhadoInterfaces";
import ParalisarManutencao from "../../ParalisarManutencao";
import { IComponentModal } from "../../../../../../Components/Modais/IModalComponent";
import IconOrSpinner from "../../../../../../Components/Utils/IconOrSpinner";
import { useHistoricoContext } from "../../../../../../Context/Historico";
import { IAcoesAcessoUsuario } from "../../../../../../Interfaces/Geral/AcaoEtapa/AcaoEtapaInterfaces";

interface IParalisarManutencaoProps {
    setShow: Dispatch<SetStateAction<boolean>>;
    setModal: Dispatch<SetStateAction<IComponentModal | undefined>>;
    AcaoAcessoUsuario: IAcoesAcessoUsuario[] | undefined;
}

export default function BotaoParalisarEReiniciarManutencao(
    props: IParalisarManutencaoProps
) {
    const { updateAtendimento } = useAtendimentoPage();
    const { ReloadHistorico } = useHistoricoContext();

    const AtendimentoPage = useAtendimentoPage();
    const Atendimento =
        AtendimentoPage.Atendimento as IAtendimentoExtraDetalhado;

    const {
        execute: reiniciarAtendimentoManutencao,
        loading: reiniciarAtendimentoManutencaoLoading,
    } = useAsyncCallback(ReiniciarAtendimentoController);

    return (
        <>
            {!Atendimento.FL_CASO_PARALIZADO ? (
                <button
                    type="button"
                    className="btn btn-sm  btn-primary m-1"
                    onClick={() => {
                        props.setShow(true);
                        props.setModal({
                            headerComponent: "Paralisar Reparo",
                            IconHeader: faStop,
                            Component: () => (
                                <ParalisarManutencao setShow={props.setShow} />
                            ),
                            size: "lg",
                        });
                    }}
                    disabled={
                        !props.AcaoAcessoUsuario?.find(
                            (acaoFiltrada) => acaoFiltrada.ID_ACAO === 26
                        )?.FL_USUARIO_ACESSA ||
                        Atendimento.FL_SINCRONIZADO === true
                    }
                >
                    <FontAwesomeIcon icon={faStop} className="mr-2" /> Paralisar
                    Reparo
                </button>
            ) : (
                <button
                    type="button"
                    className="btn btn-sm btn-shadow btn-primary m-1"
                    disabled={
                        !props.AcaoAcessoUsuario?.find(
                            (acaoFiltrada) => acaoFiltrada.ID_ACAO === 32
                        )?.FL_USUARIO_ACESSA ||
                        reiniciarAtendimentoManutencaoLoading ||
                        Atendimento.FL_SINCRONIZADO === true
                    }
                    onClick={() => {
                        if (Atendimento?.ID_CASO) {
                            reiniciarAtendimentoManutencao(
                                Atendimento.ID_CASO
                            ).then(() => {
                                updateAtendimento();
                                ReloadHistorico();
                            });
                        }
                    }}
                >
                    <IconOrSpinner
                        icon={faPlay}
                        loadingSize="sm"
                        loading={reiniciarAtendimentoManutencaoLoading}
                        className="mr-2"
                    />{" "}
                    Reiniciar Reparo
                </button>
            )}
        </>
    );
}
